import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconAdobeInDesign24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconAdobeInDesign24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 4.5h12A1.5 1.5 0 0 1 19.5 6v12a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 18V6A1.5 1.5 0 0 1 6 4.5M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm4.594 2.3V16h1.452V8.3zm3.666 7.535q.571.32 1.22.319.75 0 1.134-.253.396-.254.583-.561h.198V16h1.364V8.3h-1.386v2.871h-.198a1.4 1.4 0 0 0-.32-.374 1.6 1.6 0 0 0-.55-.286 2.4 2.4 0 0 0-.824-.121q-.66 0-1.221.33a2.34 2.34 0 0 0-.902.946q-.341.627-.341 1.518v.176q0 .891.34 1.518.342.627.903.957m2.706-1.298q-.43.407-1.067.407-.639 0-1.067-.407-.43-.418-.43-1.21v-.11q0-.792.43-1.199a1.47 1.47 0 0 1 1.067-.418q.648 0 1.067.418.429.407.429 1.199v.11q0 .792-.43 1.21"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconAdobeInDesign24);
